/* eslint-disable max-len */
import 'react';

const UpdatingSvg = (): React.PropsWithoutRef<React.ReactSVGElement> => (
    <svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <defs>
            <path id="UpdatingSvg_prefix__a" d="M0 0h12v12H0z" />
        </defs>
        <g fill="none" fillRule="evenodd">
            <mask id="UpdatingSvg_prefix__b" fill="#fff">
                <use xlinkHref="#UpdatingSvg_prefix__a" />
            </mask>
            <g
                stroke="currentColor"
                strokeWidth="1.2"
                mask="url(#UpdatingSvg_prefix__b)"
                strokeLinecap="round"
                strokeLinejoin="round"
            >
                <path d="M10.537 3.896a5 5 0 00-9.31.612M11.159 2.189l-.348 1.97-1.97-.348" />
                <g>
                    <path d="M1.916 8.104a5 5 0 009.31-.612M1.294 9.811l.347-1.97 1.97.348" />
                </g>
            </g>
        </g>
    </svg>
);
export default UpdatingSvg;
